import React, { useState } from 'react';
import { faDownload, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from "react-redux"
import { Button, Table, Alert } from 'reactstrap';
import { getpdf } from './../../../../context/actions/subscription';
import Pagination from "react-js-pagination";
import { dateFormat } from '../../../../utils/common';
import NoRecord from '../../../../../src/components/common/NoRecord'
import FilterBlock from './FilterBlock';
import './index.scss';

const PaymentTransactionTableList = ({ _plan, _trans, _subscription }) => {
	const dispatch = useDispatch();
	const [limit] = useState(10)
	const [order, setOrder] = useState(1)
	const [sortKey, setSortKet] = useState('')
	// set active page 
	const [page, setPage] = useState(1)

	const [keyword, setKeyword] = useState('')
	const savePdf = async (id) => {
		dispatch(getpdf(id, async (res) => {
			if (res) {
				const buff = Buffer.from(res.buffer);
				const file = new Blob([buff], { type: 'application/pdf' });
				const fileURL = URL.createObjectURL(file);
				window.open(fileURL);
			}
		}))
	}

	/**
	 * @description method call to update active page and call API to get respective transaction records
	 * @param {Number} activePage accepting number
	 */
	const _handlePageChange = async (activePage) => {
		setPage(activePage)
		dispatch(_subscription({ page: activePage, fields: 'transaction_id', filter: keyword, limit, sort: sortKey, order: order }))
	}

	/**
	 * @description method call to update active page and call API to get respective transaction records
	 * @param {Number} activePage accepting number
	 */
	const _handleSearch = async (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")) {
			setKeyword(val)
			dispatch(_subscription({ page: page, fields: 'transaction_id', filter: val, limit }))
		} else {
			setKeyword(val.trim().replace(/\./g, ""))
			dispatch(_subscription({ page: page, fields: 'transaction_id', filter: val.trim().replace(/\./g, ""), limit }))
		}
	}

	/**
 * @description function use for sorting records
 * @param {object} params accept object fields and filters
 */
	const handleSorting = async (params) => {
		setSortKet(params)
		let query = { page: page, sort: params, order: order === 1 ? -1 : 1 }
		setOrder(order === 1 ? -1 : 1)
		if (keyword)
			query = { ...query, fields: 'transaction_id', filter: keyword }
		dispatch(_subscription(query))
	};

	return (
		<div className='payment-transaction-blc'>
			<div>
				<Alert color="info">
					<h4 className="alert-heading">Note</h4>
					<p>
						If your transaction is not reflecting, This is because it is still in processing by the payment gateway, And we may not yet have received your payment. A payment is not considered missing until after the payment posting time frame has passed.
					</p>
					<hr />
					<p className="mb-0">
						Please Make sure to check back after 24 Hours
					</p>
				</Alert>
			</div>

			 <FilterBlock _change={_handleSearch} _keyword={keyword} />
			{_trans?.docs?.length !== 0 ? (<><div className="card">
				<Table responsive>
					<thead>
						<tr>
							<th style={{ width: '150px' }}>Pay No. <FontAwesomeIcon icon={faSort} onClick={(val) => { handleSorting('pay_num'); }} /></th>
							<th>Transaction ID <FontAwesomeIcon icon={faSort} onClick={(val) => { handleSorting('transaction_id'); }} /></th>
							<th>Date-Time <FontAwesomeIcon icon={faSort} onClick={(val) => { handleSorting('utc_time'); }} /></th>
							<th>Amount</th>
							<th style={{ width: '100px' }}>Status</th>
							<th style={{ width: '100px' }}>Action</th>
						</tr>
					</thead>
					<tbody>
						{_trans?.docs?.map((item, idx) =>
							<tr key={idx}>
								<td>{item?.pay_num}</td>
								<td>{item?.transaction_id}</td>
								<td>{dateFormat(item?.utc_time)}</td>
								<td>${item?.amount}</td>
								<td>
									<div className="status-cell success d-inline-flex align-items-center">
										<span className='d-inline-flex rounded-circle'></span>
										Success
									</div>
								</td>
								<td>
									<div className="action-btns d-flex justify-content-center">
										<Button color='secondary' onClick={() => { savePdf(item._id) }}>
											<FontAwesomeIcon icon={faDownload} />
										</Button>
									</div>
								</td>
							</tr>
						)
						}
					</tbody>
				</Table>
				<Pagination
					innerClass="pagination justify-content-end pb-10 mt-auto"
					itemClass="page-item"
					linkClass="page-link"
					prevPageText="Previous"
					nextPageText="Next"
					firstPageText="First"
					lastPageText="Last"
					activePage={page}
					itemsCountPerPage={limit}
					totalItemsCount={_trans?.totalDocs || 0}
					onChange={(activePage) => {
						_handlePageChange(activePage)
					}}
				/>
			</div></>) : (<div className="card"><NoRecord /></div>)}
		</div>
	);
}

export default PaymentTransactionTableList;